import { useEffect } from 'react';

export function GlParamCleaner() {
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('_gl')) {
      url.searchParams.delete('_gl');
      window.history.replaceState({}, '', url.pathname + url.search);
    }
  }, []);

  return null;
}
